import { render, staticRenderFns } from "./TradycyjniEuropejczycy.vue?vue&type=template&id=1af67c42&scoped=true&"
import script from "./TradycyjniEuropejczycy.vue?vue&type=script&lang=js&"
export * from "./TradycyjniEuropejczycy.vue?vue&type=script&lang=js&"
import style0 from "./TradycyjniEuropejczycy.vue?vue&type=style&index=0&id=1af67c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af67c42",
  null
  
)

export default component.exports